import { render, staticRenderFns } from "./AttemptField.vue?vue&type=template&id=588d540c&scoped=true&"
import script from "./AttemptField.vue?vue&type=script&lang=ts&"
export * from "./AttemptField.vue?vue&type=script&lang=ts&"
import style0 from "./AttemptField.vue?vue&type=style&index=0&id=588d540c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d540c",
  null
  
)

export default component.exports